const BG_GREEN_50 = 'bg-green-50'
const BG_PURPLE_10 = 'bg-purple-10'
const BG_GREEN_10 = 'bg-green-10'
const BG_PURPLE_50 = 'bg-purple-50'
const BG_YELLOW_50 = 'bg-yellow-50'
const BG_YELLOW_10 = 'bg-yellow-10'
const EDU_SMALL_YEARLY = 'edu-small-yearly'
const EDU_MEDIUM_YEARLY = 'edu-medium-yearly'
const EDU_LARGE_YEARLY = 'edu-large-yearly'
const ONE_TIME_MINI = 'one-time-mini'
const ONE_TIME_SMALL = 'one-time-small'
const ONE_TIME_MEDIUM = 'one-time-medium'
const ONE_TIME_LARGE = 'one-time-large'
const EDU_SMALL = 'edu-small'
const EDU_MEDIUM = 'edu-medium'
const EDU_LARGE = 'edu-large'
const planName = {
  PLUS_MONTHLY: 'Plus Monthly',
  PLUS_YEARLY: 'Plus Yearly',
  PRO_MONTHLY: 'Pro Monthly',
  PRO_YEARLY: 'Pro Yearly',
  ESSENTIAL_MONTHLY: 'Essential Monthly',
  ESSENTIAL_YEARLY: 'Essential Yearly',
  PRO_BIYEARLY: 'Pro 2-Year',
  ESSENTIAL_BIYEARLY: 'Essential 2-Year',
  LIFETIME: 'Lifetime',
  EDU_MEDIUM: 'Edu (Medium)',
  EDU_SMALL: 'Edu (Small)',
  TRIAL: 'Trial Plus',
  TRIAL_PRO: 'Trial Pro',
}
const allPlanTypes = {
  WHITE_LABEL: 'white-label',
  PLUS_MONTHLY: 'plus-monthly',
  PLUS_YEARLY: 'plus-yearly',
  PRO_MONTHLY: 'pro-monthly',
  PRO_YEARLY: 'pro-yearly',
  ESSENTIAL_MONTHLY: 'essential-monthly',
  ESSENTIAL_YEARLY: 'essential-yearly',
  EDU_SMALL: 'edu-small',
  EDU_SMALL_YEARLY,
  EDU_SMALL_MONTHLY: 'edu-small-monthly',
  EDU_MEDIUM,
  EDU_MEDIUM_YEARLY,
  EDU_MEDIUM_MONTHLY: 'edu-medium-monthly',
  EDU_LARGE: 'edu-large',
  EDU_LARGE_YEARLY,
  EDU_LARGE_MONTHLY: 'edu-large-monthly',
  TRIAL: 'trial-plus-monthly',
}

const PRO_PLAN_PARTICIPANT_LIMIT = 10000
// define plan for singapore
const planVietnam = [
  {
    name: planName.PLUS_MONTHLY,
    limit: 200,
    price: 8500,
    label: 'plus',
    type: allPlanTypes.PLUS_MONTHLY,
    group: 'plus',
    billingCycle: 'monthly',
    currency: 'vnd',
    gaEcommerceProductId: allPlanTypes.PLUS_MONTHLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PLUS_YEARLY,
    limit: 200,
    price: 33000,
    label: 'plus',
    type: allPlanTypes.PLUS_YEARLY,
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 11.95,
    currency: 'vnd',
    gaEcommerceProductId: allPlanTypes.PLUS_YEARLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PRO_MONTHLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 12500,
    label: 'pro',
    type: allPlanTypes.PRO_MONTHLY,
    group: 'pro',
    billingCycle: 'monthly',
    currency: 'vnd',
    gaEcommerceProductId: allPlanTypes.PRO_MONTHLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.PRO_YEARLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 48000,
    label: 'pro',
    type: allPlanTypes.PRO_YEARLY,
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 21.75,
    currency: 'vnd',
    gaEcommerceProductId: allPlanTypes.PRO_YEARLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.ESSENTIAL_MONTHLY,
    limit: 100,
    price: 6000,
    label: 'essential',
    type: allPlanTypes.ESSENTIAL_MONTHLY,
    group: 'essential',
    billingCycle: 'monthly',
    currency: 'vnd',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.ESSENTIAL_YEARLY,
    limit: 100,
    price: 24000,
    label: 'essential',
    type: allPlanTypes.ESSENTIAL_YEARLY,
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 10.75,
    currency: 'vnd',
    gaEcommerceProductId: allPlanTypes.ESSENTIAL_YEARLY,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: 'Edu Yearly Small',
    limit: 50,
    price: 9000,
    label: 'edu small yearly',
    type: allPlanTypes.EDU_SMALL_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 3.95,
    currency: 'vnd',
    gaEcommerceProductId: allPlanTypes.EDU_SMALL_YEARLY,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: 'Edu Yearly Medium',
    limit: 100,
    price: 16800,
    label: 'edu medium yearly',
    type: allPlanTypes.EDU_MEDIUM_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 7.35,
    currency: 'vnd',
    gaEcommerceProductId: allPlanTypes.EDU_MEDIUM_YEARLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: 'Edu Yearly Large',
    limit: 200,
    price: 24000,
    label: 'edu large yearly',
    type: allPlanTypes.EDU_LARGE_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 10.35,
    currency: 'vnd',
    gaEcommerceProductId: allPlanTypes.EDU_LARGE_YEARLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
]
const planSingapore = [
  {
    name: planName.PLUS_MONTHLY,
    limit: 200,
    price: 32.95,
    label: 'plus',
    type: allPlanTypes.PLUS_MONTHLY,
    group: 'plus',
    billingCycle: 'monthly',
    currency: 'sgd',
    gaEcommerceProductId: allPlanTypes.PLUS_MONTHLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PLUS_YEARLY,
    limit: 200,
    price: 177,
    label: 'plus',
    type: allPlanTypes.PLUS_YEARLY,
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 11.95,
    currency: 'sgd',
    gaEcommerceProductId: allPlanTypes.PLUS_YEARLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PRO_MONTHLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 67.65,
    label: 'pro',
    type: allPlanTypes.PRO_MONTHLY,
    group: 'pro',
    billingCycle: 'monthly',
    currency: 'sgd',
    gaEcommerceProductId: allPlanTypes.PRO_MONTHLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.PRO_YEARLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 261,
    label: 'pro',
    type: allPlanTypes.PRO_YEARLY,
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 21.75,
    currency: 'sgd',
    gaEcommerceProductId: allPlanTypes.PRO_YEARLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.ESSENTIAL_MONTHLY,
    limit: 100,
    price: 32.65,
    label: 'essential',
    type: allPlanTypes.ESSENTIAL_MONTHLY,
    group: 'essential',
    billingCycle: 'monthly',
    currency: 'sgd',
    gaEcommerceProductId: allPlanTypes.ESSENTIAL_MONTHLY,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.ESSENTIAL_YEARLY,
    limit: 100,
    price: 129,
    label: 'essential',
    type: allPlanTypes.ESSENTIAL_YEARLY,
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 10.75,
    currency: 'sgd',
    gaEcommerceProductId: allPlanTypes.ESSENTIAL_YEARLY,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: 'Edu Yearly Small',
    limit: 50,
    price: 47.4,
    label: 'edu small yearly',
    type: EDU_SMALL_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 3.95,
    currency: 'sgd',
    gaEcommerceProductId: EDU_SMALL_YEARLY,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: 'Edu Yearly Medium',
    limit: 100,
    price: 88.2,
    label: 'edu medium yearly',
    type: EDU_MEDIUM_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 7.35,
    currency: 'sgd',
    gaEcommerceProductId: EDU_MEDIUM_YEARLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: 'Edu Yearly Large',
    limit: 200,
    price: 124.2,
    label: 'edu large yearly',
    type: EDU_LARGE_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 10.35,
    currency: 'sgd',
    gaEcommerceProductId: EDU_LARGE_YEARLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
]
const planEur = [
  // Euro
  {
    name: planName.PLUS_MONTHLY,
    limit: 200,
    price: 32.95,
    label: 'plus',
    type: 'plus-monthly-eu',
    group: 'plus',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'plus-monthly-eu',
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PLUS_YEARLY,
    limit: 200,
    price: 131.40,
    label: 'plus',
    type: 'plus-yearly-eu',
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 11.95,
    currency: 'eur',
    gaEcommerceProductId: 'plus-yearly-eu',
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PRO_MONTHLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 49.95,
    label: 'pro',
    type: 'pro-monthly-eu',
    group: 'pro',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'pro-monthly-eu',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.PRO_YEARLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 191.40,
    label: 'pro',
    type: 'pro-yearly-eu',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 15.95,
    currency: 'eur',
    gaEcommerceProductId: 'pro-yearly-eu',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.ESSENTIAL_MONTHLY,
    limit: 100,
    price: 23.95,
    label: 'essential',
    type: 'essential-monthly-eu',
    group: 'essential',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'essential-monthly-eu',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.ESSENTIAL_YEARLY,
    limit: 100,
    price: 95.40,
    label: 'essential',
    type: 'essential-yearly-eu',
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 7.95,
    currency: 'eur',
    gaEcommerceProductId: 'essential-yearly-eu',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: 'Edu Small',
    limit: 50,
    price: 4.95,
    label: 'edu small',
    type: 'edu-small-eu',
    group: 'edu',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'edu-small-eu',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: 'Edu Medium',
    limit: 100,
    price: 9.95,
    label: 'edu medium',
    type: 'edu-medium-eu',
    group: 'edu',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'edu-medium-eu',
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: 'Edu Large',
    limit: 200,
    price: 23.95,
    label: 'edu large',
    type: 'edu-large-eu',
    group: 'edu',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'edu-large-eu',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: 'Edu Yearly Small',
    limit: 50,
    price: 35.40,
    label: 'edu small yearly',
    type: 'edu-small-yearly-eu',
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 2.95,
    currency: 'eur',
    gaEcommerceProductId: 'edu-small-yearly-eu',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: 'Edu Yearly Medium',
    limit: 100,
    price: 65.40,
    label: 'edu medium yearly',
    type: 'edu-medium-yearly-eu',
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 5.45,
    currency: 'eur',
    gaEcommerceProductId: 'edu-medium-yearly-eu',
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: 'Edu Yearly Large',
    limit: 200,
    price: 91.80,
    label: 'edu large yearly',
    type: 'edu-large-yearly-eu',
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 7.65,
    currency: 'eur',
    gaEcommerceProductId: 'edu-large-yearly-eu',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
]
const planGeneral = [
  {
    name: 'Free',
    limit: 50,
    price: 0,
    flashDiscount: 0,
    label: 'free',
    type: 'free',
    group: 'free',
    billingCycle: 'free',
    gaEcommerceProductId: 'free',
    color1: 'bg-primary-90',
    color2: 'bg-primary-60',
  },

  {
    name: planName.PLUS_MONTHLY,
    limit: 200,
    price: 15,
    flashDiscount: 0,
    label: 'plus',
    oldPlan: 24122019,
    type: 'plus-monthly-24122019',
    group: 'plus',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'plus-monthly-24122019',
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PLUS_YEARLY,
    limit: 200,
    price: 60,
    flashDiscount: 0,
    label: 'plus',
    oldPlan: 24122019,
    type: 'plus-yearly-24122019',
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 5.00,
    gaEcommerceProductId: 'plus-yearly-24122019',
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PRO_MONTHLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 36,
    flashDiscount: 0,
    label: 'pro',
    oldPlan: 24122019,
    type: 'pro-monthly-24122019',
    group: 'pro',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'pro-monthly-24122019',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.PRO_YEARLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 144,
    flashDiscount: 0,
    label: 'pro',
    oldPlan: 24122019,
    type: 'pro-yearly-24122019',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 12,
    gaEcommerceProductId: 'pro-yearly-24122019',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.PRO_MONTHLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 59.95,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-monthly-10012020',
    group: 'pro',
    billingCycle: 'monthly',
    oldPlan: 10012020,
    gaEcommerceProductId: 'pro-monthly-10012020',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.PRO_YEARLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 239.40,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-yearly-10012020',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 19.95,
    oldPlan: 10012020,
    gaEcommerceProductId: 'pro-yearly-10012020',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },

  // new plan 24122019
  {
    name: planName.ESSENTIAL_MONTHLY,
    limit: 100,
    price: 23.95,
    flashDiscount: 9,
    label: 'essential',
    type: 'essential-monthly-07122022',
    group: 'essential',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'essential-monthly-07122022',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.ESSENTIAL_YEARLY,
    limit: 100,
    price: 95.40,
    flashDiscount: 36,
    label: 'essential',
    type: 'essential-yearly-07122022',
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 7.95,
    gaEcommerceProductId: 'essential-yearly-07122022',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.ESSENTIAL_MONTHLY,
    limit: 100,
    price: 23.95,
    flashDiscount: 9,
    label: 'essential',
    type: allPlanTypes.ESSENTIAL_MONTHLY,
    group: 'essential',
    billingCycle: 'monthly',
    gaEcommerceProductId: allPlanTypes.ESSENTIAL_MONTHLY,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.ESSENTIAL_YEARLY,
    limit: 100,
    price: 95.40,
    flashDiscount: 36,
    label: 'essential',
    type: allPlanTypes.ESSENTIAL_YEARLY,
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 7.95,
    gaEcommerceProductId: allPlanTypes.ESSENTIAL_YEARLY,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },

  {
    name: planName.PLUS_MONTHLY,
    limit: 200,
    price: 32.95,
    flashDiscount: 0,
    label: 'plus',
    type: allPlanTypes.PLUS_MONTHLY,
    group: 'plus',
    billingCycle: 'monthly',
    gaEcommerceProductId: allPlanTypes.PLUS_MONTHLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PLUS_YEARLY,
    limit: 200,
    price: 131.40,
    flashDiscount: 0,
    label: 'plus',
    type: allPlanTypes.PLUS_YEARLY,
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 10.95,
    gaEcommerceProductId: allPlanTypes.PLUS_YEARLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.PRO_MONTHLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 49.95,
    flashDiscount: 0,
    label: 'pro',
    type: allPlanTypes.PRO_MONTHLY,
    group: 'pro',
    billingCycle: 'monthly',
    gaEcommerceProductId: allPlanTypes.PRO_MONTHLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.PRO_YEARLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 191.40,
    flashDiscount: 0,
    label: 'pro',
    type: allPlanTypes.PRO_YEARLY,
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 15.95,
    gaEcommerceProductId: allPlanTypes.PRO_YEARLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.PRO_BIYEARLY,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 263.40,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-biyearly',
    group: 'pro',
    billingCycle: 'biyearly',
    perMonth: 10.98,
    gaEcommerceProductId: 'pro-biyearly',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.ESSENTIAL_BIYEARLY,
    limit: 100,
    price: 195.95,
    flashDiscount: 0,
    label: 'essential',
    type: 'essential-biyearly',
    group: 'essential',
    billingCycle: 'biyearly',
    perMonth: 8.16,
    gaEcommerceProductId: 'essential-biyearly',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.LIFETIME,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 549.95,
    flashDiscount: 0,
    label: 'pro',
    type: 'ahaslides-lifetime',
    group: 'pro',
    billingCycle: 'lifetime',
    gaEcommerceProductId: 'ahaslides-lifetime',
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: planName.EDU_SMALL,
    limit: 50,
    price: 4.95,
    flashDiscount: 0,
    label: 'edu (small)',
    type: EDU_SMALL,
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: EDU_SMALL,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.EDU_SMALL,
    limit: 50,
    price: 35.40,
    flashDiscount: 12,
    perMonth: 2.95,
    label: 'edu (small)',
    type: 'edu-small-yearly-07122022',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-small-yearly-07122022',
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.EDU_SMALL,
    limit: 50,
    price: 35.40,
    flashDiscount: 12,
    perMonth: 2.95,
    label: 'edu (small)',
    type: EDU_SMALL_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: EDU_SMALL_YEARLY,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: planName.EDU_MEDIUM,
    limit: 100,
    price: 9.95,
    flashDiscount: 0,
    label: 'edu (medium)',
    type: EDU_MEDIUM,
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: EDU_MEDIUM,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.EDU_MEDIUM,
    limit: 100,
    price: 65.40,
    flashDiscount: 24,
    perMonth: 5.45,
    label: 'edu (medium)',
    type: 'edu-medium-yearly-07122022',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-medium-yearly-07122022',
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: planName.EDU_MEDIUM,
    limit: 100,
    price: 65.40,
    flashDiscount: 24,
    perMonth: 5.45,
    label: 'edu (medium)',
    type: EDU_MEDIUM_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: EDU_MEDIUM_YEARLY,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: 'Edu (Large)',
    limit: 200,
    price: 23.95,
    flashDiscount: 0,
    label: 'edu (large)',
    type: EDU_LARGE,
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: EDU_LARGE,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: 'Edu (Large)',
    limit: 200,
    price: 91.80,
    flashDiscount: 0,
    perMonth: 7.65,
    label: 'edu (large)',
    type: EDU_LARGE_YEARLY,
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: EDU_LARGE_YEARLY,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: 'One-Time (Mini)',
    limit: 15,
    price: 4.95,
    flashDiscount: 2,
    label: 'one-time (mini)',
    type: ONE_TIME_MINI,
    group: 'one-time',
    gaEcommerceProductId: ONE_TIME_MINI,
    color1: 'bg-primary-90',
    color2: 'bg-primary-60',
  },
  {
    name: 'One-Time (Small)',
    limit: 30,
    price: 10.95,
    flashDiscount: 4,
    label: 'one-time (small)',
    type: ONE_TIME_SMALL,
    group: 'one-time',
    gaEcommerceProductId: ONE_TIME_SMALL,
    color1: BG_YELLOW_50,
    color2: BG_YELLOW_10,
  },
  {
    name: 'Festive Gathering',
    limit: 100,
    price: 19.9,
    flashDiscount: 0,
    label: 'one-time (medium)',
    type: ONE_TIME_MEDIUM,
    group: 'one-time',
    gaEcommerceProductId: ONE_TIME_MEDIUM,
    color1: BG_GREEN_50,
    color2: BG_GREEN_10,
  },
  {
    name: 'Festive Celebration',
    limit: 2500,
    price: 36.90,
    flashDiscount: 0,
    label: 'one-time (large)',
    type: ONE_TIME_LARGE,
    group: 'one-time',
    gaEcommerceProductId: ONE_TIME_LARGE,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  },
  {
    name: 'White Label',
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 395.00,
    flashDiscount: 0,
    label: 'white label',
    type: allPlanTypes.WHITE_LABEL,
    group: allPlanTypes.WHITE_LABEL,
    billingCycle: 'yearly',
    gaEcommerceProductId: allPlanTypes.WHITE_LABEL,
    color1: 'bg-secondary-50',
    color2: 'bg-secondary-15',
  },
  {
    name: planName.TRIAL,
    limit: 200,
    price: 0,
    flashDiscount: 0,
    label: 'trial',
    type: 'trial-plus-monthly',
    group: 'plus',
    billingCycle: 'monthly',
    gaEcommerceProductId: allPlanTypes.PLUS_MONTHLY,
    color1: 'bg-green-50',
    color2: BG_GREEN_10,
  },
  {
    name: planName.TRIAL_PRO,
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 0,
    flashDiscount: 0,
    label: 'trial',
    type: 'trial-pro-monthly',
    group: 'pro',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'pro-monthly',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Ultimate Daily',
    limit: PRO_PLAN_PARTICIPANT_LIMIT,
    price: 0.04,
    label: 'ultimate',
    type: 'ultimate-daily',
    group: 'pro',
    billingCycle: 'daily',
    gaEcommerceProductId: 'ultimate-daily',
    color1: 'bg-red-50',
    color2: 'bg-red-10',
  },
]
const plans = [
  ...planGeneral,
  ...planSingapore,
  ...planEur,
  ...planVietnam,
]

// const NEW_FREE_PLAN_TEST_GROUP_CONTRIES = [
//   'Vietnam',
//   'Singapore',
//   'Netherlands',
//   'Taiwan',
//   'Germany',
//   'Italy',
//   'Philippines',
//   'Spain',
//   'Malaysia',
//   'Mexico',
//   'Uzbekistan',
//   // add more countries for test group here
// ]

// BOO-630 — synthesize a display plan for a bucket the static catalog does not
// know: a one-time / marketplace product sold via Stripe config only. The display
// NAME comes from the backend (the Stripe product name via /my-plan or the redeem
// response), so a brand-new product reaches the plan badge + My Plan page with no
// per-product FE code change. Shaped like a static `plans` entry so every consumer
// (badge visibility reads `group`, My Plan title reads `name`, lifetime styling
// reads `billingCycle`) keeps working unchanged.
function buildMarketplacePlan({
  type, name, billingCycle = 'lifetime', limit = PRO_PLAN_PARTICIPANT_LIMIT,
} = {}) {
  return {
    name: name || planName.LIFETIME,
    type,
    group: 'pro',
    billingCycle,
    limit,
    label: 'pro',
    price: 0,
    color1: BG_PURPLE_50,
    color2: BG_PURPLE_10,
  }
}

function getPlanByType(type, currency = undefined) {
  let plan = null
  if (currency === 'ideal') {
    plan = plans.find((item) => (
      item.type.includes(type)
        && item.currency === 'eur'
    ))
  } else if (['sgd', 'vnd', 'eur'].includes(currency)) {
    plan = plans.find((item) => (
      item.type.includes(type)
        && item.currency === currency
    ))
  } else {
    plan = plans.find((item) => (
      item.type === type
    ))
  }
  return plan
}

export default {
  plans,
  getPlanByType,
  buildMarketplacePlan,
  allPlanTypes,

  _checkPermissionUpgrade(planType, permission, data) {
    if (planType === 'free') return

    if (planType === ONE_TIME_MINI) {
      permission.oneTimeMini = true
    }
    if (planType === ONE_TIME_SMALL) {
      permission.oneTimeSmall = true
    }
    if (planType === ONE_TIME_MEDIUM) {
      permission.oneTimeMedium = true
      permission.essentialMonthly = true
    }
    if (planType === ONE_TIME_LARGE) {
      permission.oneTimeLarge = true
      permission.essentialMonthly = true
      permission.plusMonthly = true
    }
    if (planType === EDU_SMALL_YEARLY) {
      permission.eduSmallYearly = true
    }
    if (planType === EDU_MEDIUM_YEARLY) {
      permission.eduSmallYearly = true
      permission.eduMediumYearly = true
    }
    if (planType === EDU_LARGE_YEARLY) {
      permission.eduSmallYearly = true
      permission.eduMediumYearly = true
      permission.eduLargeYearly = true
    }
    if (planType === allPlanTypes.ESSENTIAL_MONTHLY) {
      permission.essentialMonthly = true
    }
    if (planType === allPlanTypes.ESSENTIAL_YEARLY) {
      permission.essentialYearly = true
    }
    if (planType === allPlanTypes.PLUS_MONTHLY) {
      permission.plusMonthly = true
    }
    if (planType === allPlanTypes.PLUS_YEARLY) {
      permission.plusYearly = true
    }
    if (planType === allPlanTypes.PRO_MONTHLY) {
      permission.proMonthly = true
    }
    if (planType === allPlanTypes.PRO_YEARLY) {
      permission.proMonthly = true
      permission.proYearly = true
      permission.plusYearly = true
      permission.plusMonthly = true
      permission.essentialMonthly = true
      permission.essentialYearly = true
    }

    if (data && data.subscription && data.oneTime) {
      permission = {
        essentialMonthly: true,
        essentialYearly: true,
        plusMonthly: true,
        plusYearly: true,
        proMonthly: true,
        proYearly: true,
        eduSmallYearly: true,
        eduMediumYearly: true,
        eduLargeYearly: true,
      }

      if (planType === ONE_TIME_MINI) {
        permission.oneTimeMini = true
      }
      if (planType === ONE_TIME_SMALL) {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
      }
      if (planType === ONE_TIME_MEDIUM) {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
      }
      if (planType === ONE_TIME_LARGE) {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
        permission.oneTimeLarge = true
      }
      return
    }

    if (planType === ONE_TIME_MINI) {
      permission.oneTimeMini = true
    }
    if (planType === ONE_TIME_SMALL) {
      permission.oneTimeMini = true
      permission.oneTimeSmall = true
    }
    if (planType === ONE_TIME_MEDIUM) {
      permission.oneTimeMini = true
      permission.oneTimeSmall = true
      permission.oneTimeMedium = true
    }
    if (planType === ONE_TIME_LARGE) {
      permission.oneTimeMini = true
      permission.oneTimeSmall = true
      permission.oneTimeMedium = true
      permission.oneTimeLarge = true
    }

    if (data.subscription && !data.oneTime) {
      //
      const subPlan = getPlanByType(data.subscription.type, data.subscription.currency)

      plans.forEach((item) => {
        const isBulkLicense = data.subscription && data.subscription.quantity > 1
        const isSubVND = data.subscription.currency === 'vnd' && item.currency === 'vnd'
        const isCreditEnough = data.subscription.currency === 'vnd' ?
          item.price < data.subscription.credit && isSubVND :
          item.price < data.subscription.credit
        if (isCreditEnough || isBulkLicense) {
          if (item.type === allPlanTypes.ESSENTIAL_MONTHLY) {
            permission.essentialMonthly = true
          }
          if (item.type === allPlanTypes.ESSENTIAL_YEARLY) {
            permission.essentialYearly = true
          }
          if (item.type === allPlanTypes.PLUS_MONTHLY) {
            permission.plusMonthly = true
          }
          if (item.type === allPlanTypes.PLUS_YEARLY) {
            permission.plusYearly = true
          }
          if (item.type === allPlanTypes.PRO_MONTHLY) {
            permission.proMonthly = true
          }
          if (item.type === allPlanTypes.PRO_YEARLY) {
            permission.proYearly = true
          }
          if (item.type === EDU_SMALL_YEARLY) {
            permission.eduSmallYearly = true
          }
          if (item.type === EDU_MEDIUM_YEARLY) {
            permission.eduMediumYearly = true
          }
          if (item.type === EDU_LARGE_YEARLY) {
            permission.eduLargeYearly = true
          }
        }
      })

      if (subPlan) {
        if (subPlan.group !== 'edu' && subPlan.billingCycle === 'yearly') {
          permission.eduSmallYearly = true
          permission.eduMediumYearly = true
          permission.eduLargeYearly = true
        }

        if (subPlan.group === 'essential') {
          permission.oneTimeMini = true
          permission.oneTimeSmall = true
        }
        if (subPlan.group === 'plus') {
          permission.oneTimeMini = true
          permission.oneTimeSmall = true
          permission.oneTimeMedium = true
        }
        if (subPlan.group === 'pro') {
          permission.oneTimeMini = true
          permission.oneTimeSmall = true
          permission.oneTimeMedium = true
          permission.oneTimeLarge = true
        }
        if (subPlan.type === EDU_SMALL) {
          permission.oneTimeMini = true
        }
        if (subPlan.type === EDU_MEDIUM) {
          permission.oneTimeMini = true
          permission.oneTimeSmall = true
        }
        if (subPlan.type === EDU_LARGE) {
          permission.oneTimeMini = true
          permission.oneTimeSmall = true
          permission.oneTimeMedium = true
        }
      }

      return
    }

    if (!data.subscription && data.oneTime) {
      if (planType === ONE_TIME_MINI) {
        permission.oneTimeMini = true
      }
      if (planType === ONE_TIME_SMALL) {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
      }
      if (planType === ONE_TIME_MEDIUM) {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
      }
      if (planType === ONE_TIME_LARGE) {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
        permission.oneTimeLarge = true
      }
      plans.forEach((item) => {
        if (item.price < data.oneTime.price) {
          if (item.type === allPlanTypes.ESSENTIAL_MONTHLY) {
            permission.essentialMonthly = true
          }
          if (item.type === allPlanTypes.ESSENTIAL_YEARLY) {
            permission.essentialYearly = true
          }
          if (item.type === allPlanTypes.PLUS_MONTHLY) {
            permission.plusMonthly = true
          }
          if (item.type === allPlanTypes.PLUS_YEARLY) {
            permission.plusYearly = true
          }
          if (item.type === allPlanTypes.PRO_MONTHLY) {
            permission.proMonthly = true
          }
          if (item.type === allPlanTypes.PRO_YEARLY) {
            permission.proYearly = true
          }
          if (item.type === EDU_SMALL_YEARLY) {
            permission.eduSmallYearly = true
          }
          if (item.type === EDU_MEDIUM_YEARLY) {
            permission.eduMediumYearly = true
          }
          if (item.type === EDU_LARGE_YEARLY) {
            permission.eduLargeYearly = true
          }
        }
      })
    }
  },

  typePayment: {
    createNewOneTime: 'create-new-one-time',
    createNewSubscrition: 'create-new-subscription',
    updateOneTime: 'update-one-time',
    updateSubscription: 'update-subscription',
    createNewSubscriptionRemoveOneTime: 'create-new-subscription-remove-one-time',
  },
}
